import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Snackbar } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useState } from 'react';

import { GoogleMap, LoadScript, Marker, MarkerClusterer, InfoWindow } from '@react-google-maps/api';
import Map from './google-map/Map';
import { api_call, console_log, is_null } from './helpers/untils';
import DeviceInfoWindow from './google-map/DeviceInfoWindow';
import { useRef } from 'react';
import DeviceMarker from './google-map/DeviceMarker';

const defaultMapZoom = 13
const gapPosition = 0.001

const TemporaryFacilityMap = (props) => {
  const {
    shuttleInfo = {},
    deviceList = [],
    deviceMarkerList = []
  } = props;
  // console_log(`shuttleInfo::::`, shuttleInfo)

  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const [map, setMap] = useState(null)
  const [googleMapKey, setGoogleMapKey] = useState('');

  ///////////////////// init map center location //////////////////////////////
  const defaultPosition = { lat: 0, lng: 0 } // {lat: DEFAULT_GEO_LOCATION[0], lng: DEFAULT_GEO_LOCATION[1]}
  const [currentPosition, setCurrentPosition] = useState(defaultPosition);
  const currentPositionRef = useRef(defaultPosition);
  const geolocationNotifiedRef = useRef(false);

  const initCurrentLocation = () => {
    console.log(`initCurrentLocation::::::::`);
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const positionData = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }
        console.log(`current-positionData::::`, positionData)
        setCurrentPosition(positionData);
        currentPositionRef.current = positionData;
        geolocationNotifiedRef.current = true;
      });
    } else {
      console.log("Geolocation is not available in your browser.");
      alert("Geolocation is not available in your browser.");
    }
  }

  const loadGoogleMapKey = async () => {
    const response = await api_call(`/api/get-env-info`);
    if (response.ok) {
      const apiResObj = await response.json()
      setGoogleMapKey(apiResObj['GOOGLE_MAP_KEY'])
    }
  }

  useEffect(() => {
    initCurrentLocation()
    loadGoogleMapKey()
    onLoadMapLocatedToUserLocation()
  }, []);

  const onLoadMapLocatedToUserLocation = () => {
    setTimeout(() => {
      if (!geolocationNotifiedRef.current) {
        askMapLocatedToUserLocation();
      }
    }, 5000);
  }

  const askMapLocatedToUserLocation = () => {
    const currentPositionData = currentPositionRef.current;
    if (currentPositionData.lat === 0 && currentPositionData.lng === 0) {
      alert("Please allow location access to view the map centered on your location.");
      geolocationNotifiedRef.current = true;
      initCurrentLocation();
      return false;
    } else {
      geolocationNotifiedRef.current = true;
      return true;
    }
  }

  useEffect(() => {
    console_log(`deviceMarkerList:::`, deviceMarkerList)
    const marker_list = createMarkers(deviceMarkerList)
    console_log(`marker_list:::`, marker_list)
    setMarkers(marker_list)
  }, [deviceMarkerList])

  const uniquePositionsRef = useRef([])
  const getNewPosition = (unique_positions, position) => {
    let originPosition = { ...position }
    position = {
      lat: position.lat + gapPosition,
      lng: position.lng + gapPosition,
    }
    let positionStr = `${position.lat.toFixed(7)},${position.lng.toFixed(7)}`
    while (unique_positions.includes(positionStr)) {
      position = {
        lat: position.lat + gapPosition,
        lng: position.lng + gapPosition,
      }
      positionStr = `${position.lat.toFixed(7)},${position.lng.toFixed(7)}`
    }
    return position
  }

  const createMarkers = (device_list) => {
    const marker_list = []
    let unique_positions = uniquePositionsRef.current
    for (let k in device_list) {
      const row = device_list[k]
      if (!is_null(row.latitude) && !is_null(row.longitude)) {
        let position = { lat: row.latitude, lng: row.longitude }
        // let positionStr = `${position.lat.toFixed(7)},${position.lng.toFixed(7)}`
        // let isDuplicated = false
        // if (unique_positions.includes(positionStr)) {
        //   position = getNewPosition(unique_positions, position)
        //   positionStr = `${position.lat.toFixed(7)},${position.lng.toFixed(7)}`
        //   unique_positions.push(positionStr)
        //   isDuplicated = true
        // } else {
        //   unique_positions.push(positionStr)
        //   isDuplicated = false
        // }

        const marker_info = {
          //...row,
          id: row.id,
          position: position,
          label: `${row.name}`,
          data: row,
          // isDuplicated: isDuplicated
        }
        marker_list.push(marker_info)
      }
    }
    console_log(`unique_positions:::`, unique_positions)
    uniquePositionsRef.current = unique_positions
    return marker_list
  }

  const defaultMarkers = [
    // { position: { lat: 40.748817, lng: -73.985428 }, label: 'AAAAAAAA 111' },
    // { position: { lat: 40.74817, lng: -73.98628 }, label: 'BBB DFDDDF aaaER eEee' },
  ];
  const [markers, setMarkers] = useState(defaultMarkers)
  const [currentMarker, setCurrentMarker] = useState()
  const [currentDeviceData, setCurrentDeviceData] = useState()
  const [openDeviceInfoWindow, setOpenDeviceInfoWindow] = useState(false)

  const handleMarkerClick = async (marker) => {
    console.log(`onClickMarker, marker::::`, marker)
    const ask = askMapLocatedToUserLocation();
    if (!ask) {
      console.log(`askMapLocatedToUserLocation false:::`)
      return false;
    }

    setOpenDeviceInfoWindow(false)
    const deviceId = Number(marker.id)
    const deviceInfo = deviceList.find((item) => item.id === deviceId)
    console.log(`handleMarkerClick deviceInfo:::::`, deviceInfo);
    setCurrentDeviceData(deviceInfo);
    setCurrentMarker(marker);
    setTimeout(() => {
      setOpenDeviceInfoWindow(true);
    }, 10)
  }

  const getCurrentMarkerPosition = (id) => {
    if (id) {
      const row = deviceMarkerList.find((item) => item.id === id)
      const position = { lat: row?.latitude, lng: row?.longitude }
      return position
    } else {
      return null;
    }
  }

  useEffect(() => {
    if (map) {
      // const bounds = new window.google.maps.LatLngBounds();
      // Extend the bounds with the marker's position
      // bounds.extend(currentPosition);
      // map.fitBounds(bounds);

      console.log(`map loaded currentPosition::::`, currentPosition)
      // Set the central position after the map is loaded
      map.setCenter(currentPosition);
      map.setZoom(defaultMapZoom);
      map.panTo(currentPosition);
    }
  }, [currentPosition, map]);

  /////////////////////////////////////////////////////////////////////
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toast, setToast] = useState("");
  const showToast = (msg) => {
    setToast(msg)
    setSnackbarOpen(true)
  }

  return (
    <>
      <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
        <div style={{ position: 'fixed', left: '0px', right: '0px', top: '0px', background: '#ffffff', zIndex: 1, textAlign: 'center', padding: '14px' }}>
          <Typography noWrap={true} style={{ fontWeight: '600' }}>{shuttleInfo?.facility_name}</Typography>
        </div>
        <>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toast}
          />
        </>

        {googleMapKey && (
          <Map
            map={map}
            setMap={setMap}
            googleMapKey={googleMapKey}
            currentPosition={currentPosition}
            zoom={defaultMapZoom}
          >
            { /* Child components, such as markers, info windows, etc. */}

            <>
              <MarkerClusterer
                averageCenter
                enableRetinaIcons
                gridSize={60}
              >
                {(clusterer) => markers.map((marker, index) => (
                  // <Marker
                  //   key={index}
                  //   position={marker.position}
                  //   label={marker.label}
                  //   clusterer={clusterer}
                  // />

                  <DeviceMarker
                    key={index}
                    position={marker.position}
                    label={marker.label}
                    clusterer={clusterer}
                    onClick={(markerInfo) => handleMarkerClick(markerInfo)}
                    marker={marker}
                    currentMarker={currentMarker}
                    currentDeviceData={currentDeviceData}
                  />
                ))}
              </MarkerClusterer>

              {(currentMarker && currentDeviceData && openDeviceInfoWindow) && (
                <>
                  <DeviceInfoWindow
                    position={getCurrentMarkerPosition(currentMarker.id)}
                    marker={currentMarker}
                    setCurrentMarker={setCurrentMarker}
                    currentDeviceData={currentDeviceData}
                    open={openDeviceInfoWindow}
                    setOpen={setOpenDeviceInfoWindow}
                    currentPosition={currentPosition}
                    deviceList={deviceList}
                    shuttleInfo={shuttleInfo}
                  />
                </>
              )}
            </>
          </Map>
        )}
      </div>
    </>
  )
}

export default TemporaryFacilityMap // React.memo(TemporaryFacilityMap)